import React from 'react';
import { useDispatch } from 'react-redux';
import { Typography, Box } from '@mui/material';
import {
  SwitchStyled,
  SelectionBoxStyled,
  SelectionTitleStyled
} from '../style';
import { useAppSelector } from '../../../../store/hooks';

import digestiveIcon from '../../../../assets/icons/digestiveIcon.svg';
import { setGlim } from '../../../../store/slices/metaDataSlice';
import { metaDataSelector } from '../../../../store/globalSelectors';
import { PlaceholderGrid, CutOffIcon } from '../../../../styles/globalStyles';
import Line from '../../../../shared/components/line/index';

export const EtilogicalCriteria = () => {
  const dispatch = useDispatch();
  const {
    malnutritionScreening: { glim }
  } = useAppSelector(metaDataSelector);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%'
        }}
      >
        <CutOffIcon>
          <img src={digestiveIcon} alt="glim" />
        </CutOffIcon>
        <PlaceholderGrid container width={'100%'}>
          <Typography
            sx={{
              fontSize: '1.125rem',
              lineHeight: '1.5rem',
              textAlign: 'center',
              paddingTop: '1.25rem',
              textTransform: 'uppercase',
              color: '#002A3A',
              fontFamily: 'BGBold'
            }}
          >
            Etiological criteria
          </Typography>
          <SelectionBoxStyled>
            <SelectionTitleStyled variant="h4">
              Does the patient have reduced food intake of
            </SelectionTitleStyled>
            <SwitchStyled
              checked={glim.etiologicalCriteria.reducedNutritionIntake}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                dispatch(
                  setGlim({
                    ...glim,
                    etiologicalCriteria: {
                      ...glim.etiologicalCriteria,
                      reducedNutritionIntake: event.target.checked
                    }
                  })
                );
              }}
              inputProps={{ 'aria-label': 'Switch-Toggle', role: 'checkbox' }}
              data-testid="reducedNutritionIntake"
            />
          </SelectionBoxStyled>
          <Typography
            sx={{
              fontSize: '1rem',
              lineHeight: '1.25rem',
              textAlign: 'left',
              paddingTop: '1.25rem',
              textTransform: 'uppercase',
              fontWeight: 400,
              color: '#002A3A',
              marginBottom: '1.25rem',
              fontFamily: 'CalibriItalic'
            }}
          >
            {'<'} 50% estimated requirements {'>'} 1 week, or any reduction for{' '}
            {'>'} 2 weeks
          </Typography>
          <Line color="#D9D9D6" height="0.0625rem" />
          <SelectionBoxStyled>
            <SelectionTitleStyled variant="h4">
              Does the patient have an acute disease/injury or chronic
              disease-related inflammation
            </SelectionTitleStyled>
            <SwitchStyled
              checked={glim.etiologicalCriteria.isPatientInjured}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                dispatch(
                  setGlim({
                    ...glim,
                    etiologicalCriteria: {
                      ...glim.etiologicalCriteria,
                      isPatientInjured: event.target.checked
                    }
                  })
                );
              }}
              inputProps={{ 'aria-label': 'Switch-Toggle', role: 'checkbox' }}
              data-testid="isPatientInjured"
            />
          </SelectionBoxStyled>
          <Line color="#D9D9D6" height="0.0625rem" />
          <SelectionBoxStyled>
            <SelectionTitleStyled variant="h4">
              Does the patient have a chronic gastrointestinal condition that
              adversely impacts food assimilation or absorption?
            </SelectionTitleStyled>
            <SwitchStyled
              checked={glim.etiologicalCriteria.isPatientHasIntestineIssue}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                dispatch(
                  setGlim({
                    ...glim,
                    etiologicalCriteria: {
                      ...glim.etiologicalCriteria,
                      isPatientHasIntestineIssue: event.target.checked
                    }
                  })
                );
              }}
              inputProps={{ 'aria-label': 'Switch-Toggle', role: 'checkbox' }}
              data-testid="isPatientHasIntestineIssue"
            />
          </SelectionBoxStyled>
        </PlaceholderGrid>
      </Box>
    </>
  );
};
